// RTK Query tag types and IDs for suggestions API
export const SUGGESTIONS_TAG_TYPES = {
  SUGGESTIONS: 'Suggestions',
} as const;

export const SUGGESTIONS_TAG_IDS = {
  SPECIALTIES: 'SPECIALTIES',
  CRM_STATUSES: 'CRM_STATUSES',
} as const;

// Export individual constants for easier use with 'as const'
export const SUGGESTIONS_TAG_TYPE = 'Suggestions' as const;
export const SPECIALTIES = 'SPECIALTIES' as const;
export const CRM_STATUSES = 'CRM_STATUSES' as const;
